export const speciesEvidenceAudit = {
  auditDate: "2026-07-26",
  scope:
    "Public parasite single-cell or single-nucleus transcriptomics with accessible cell-level expression and metadata",
  result:
    "No qualifying parasite single-cell dataset was identified for the seven evidence-gap taxa below.",
  caveat:
    "This is a dated, source-bounded search result rather than proof that no unpublished or newly released dataset exists.",
  taxa: [
    {
      slug: "tbg",
      species: "Trypanosoma brucei gambiense",
      atlasStatus: "evidence-gap",
      closestEvidence: "GSE18065",
      evidenceType: "bulk digital gene-expression libraries",
      scope:
        "Six parasite libraries: three procyclic and three bloodstream-form biological replicates.",
      exclusion:
        "Bulk libraries do not provide cell-resolved expression, cell metadata or single-cell coordinates.",
      primaryUrl:
        "https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=GSE18065",
      repositoryUrl: "https://www.ncbi.nlm.nih.gov/sra/?term=SRP001797",
      repositoryLabel: "SRA SRP001797",
    },
    {
      slug: "tbr",
      species: "Trypanosoma brucei rhodesiense",
      atlasStatus: "evidence-gap",
      closestEvidence: "PMID 29474390",
      evidenceType: "bulk transcriptomes",
      scope:
        "Parasites sampled from patient blood and cerebrospinal fluid, with rat and culture comparisons.",
      exclusion:
        "The publication reports population-level transcriptomes rather than cell-resolved parasite profiles.",
      primaryUrl: "https://pubmed.ncbi.nlm.nih.gov/29474390/",
      repositoryUrl: "https://doi.org/10.1371/journal.pntd.0006280",
      repositoryLabel: "PLOS Neglected Tropical Diseases",
    },
    {
      slug: "tco",
      species: "Trypanosoma congolense",
      atlasStatus: "evidence-gap",
      closestEvidence: "GSE165290",
      evidenceType: "bulk RNA-seq",
      scope:
        "Sixteen RNA-seq samples spanning two conditions, two species and four replicates per combination.",
      exclusion:
        "Samples are bulk populations. A separate mouthpart-transcriptomics paper explicitly describes parasite single-cell RNA-seq as future work.",
      primaryUrl:
        "https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=GSE165290",
      repositoryUrl:
        "https://pmc.ncbi.nlm.nih.gov/articles/PMC9063227/",
      repositoryLabel: "Mouthpart transcriptomics paper",
    },
    {
      slug: "tvi",
      species: "Trypanosoma vivax",
      atlasStatus: "evidence-gap",
      closestEvidence: "BioProject PRJNA144513",
      evidenceType: "bulk lifecycle RNA-seq and proteomics",
      scope:
        "Global gene-expression profiling across the T. vivax lifecycle.",
      exclusion:
        "Lifecycle profiles are population averages and do not expose per-cell expression or single-cell embeddings.",
      primaryUrl: "https://pubmed.ncbi.nlm.nih.gov/26266535/",
      repositoryUrl: "https://www.ncbi.nlm.nih.gov/bioproject/144513",
      repositoryLabel: "NCBI BioProject 144513",
    },
    {
      slug: "tev",
      species: "Trypanosoma evansi",
      atlasStatus: "evidence-gap",
      closestEvidence: "GSE202334 and GSE184265",
      evidenceType: "expression microarray and bulk RNA-seq",
      scope:
        "GSE202334 exposes 64 array samples; GSE184265 includes triplicate bulk RNA-seq samples for T. evansi, T. equiperdum and T. brucei.",
      exclusion:
        "Neither record contains cell-resolved parasite expression suitable for a single-cell atlas.",
      primaryUrl:
        "https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=GSE202334",
      repositoryUrl:
        "https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=GSE184265",
      repositoryLabel: "GEO GSE184265",
    },
    {
      slug: "teq",
      species: "Trypanosoma equiperdum",
      atlasStatus: "evidence-gap",
      closestEvidence: "GSE184265",
      evidenceType: "bulk RNA-seq",
      scope:
        "Triplicate population RNA-seq samples for T. equiperdum alongside T. evansi and T. brucei.",
      exclusion:
        "The experimental unit is a bulk parasite population, not an individual cell.",
      primaryUrl:
        "https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=GSE184265",
      repositoryUrl: "https://www.ncbi.nlm.nih.gov/sra/?term=SRP337410",
      repositoryLabel: "SRA SRP337410",
    },
    {
      slug: "tra",
      species: "Trypanosoma rangeli",
      atlasStatus: "evidence-gap",
      closestEvidence: "NCBI Taxonomy 5698",
      evidenceType: "genome and gene records; no qualifying expression atlas",
      scope:
        "The species has public taxonomy, genome and gene resources, but the portal search did not identify an accessible parasite single-cell transcriptomics record.",
      exclusion:
        "Genome annotation is a reference resource, not cell-level expression evidence.",
      primaryUrl: "https://www.ncbi.nlm.nih.gov/taxonomy/5698",
      repositoryUrl:
        "https://www.ncbi.nlm.nih.gov/datasets/genome/?taxon=5698",
      repositoryLabel: "NCBI genome records",
    },
  ],
} as const;
